query getFilterItems(
  $filter: InsightFilter
  $searchTermsKey: String
  $searchTermsValues: [String]
) {
  filterItems: getFilters(
    filter: $filter
    searchTermsKey: $searchTermsKey
    searchTermsValues: $searchTermsValues
  ) {
    key
    items {
      key
      label
      optionalLabel
    }
  }
}

query getTagFilterItems(
  $filter: InsightFilter
  $searchTermsKey: String
  $searchTermsValues: [String]
) {
  filterItems: getTagFilters(
    filter: $filter
    searchTermsKey: $searchTermsKey
    searchTermsValues: $searchTermsValues
  ) {
    key
    items {
      key
      label
      optionalLabel
    }
  }
}
